import React, { FC } from 'react';
import Slider from 'react-slick';

import { GameWrap } from '../common/game-wrap';
import { GameWrapProps } from '../common/types';
import { Chest } from './chest';

type Props = Omit<GameWrapProps, 'GameContent'>;

const ChestGame: FC<Props> = (props) => {
  return <GameWrap {...props} GameContent={Chest} Slider={Slider} />;
};

export { ChestGame };

export default ChestGame;
